import React from 'react';

import { Skeleton } from 'src/component/ds/ui/skeleton';

export function TotalSkeleton () {
  return <Skeleton className='ds-h-12 ds-w-[64px]' data-testid='triaged-alarms-total-skeleton' />;
}

export function MetricsSkeleton () {
  return (
    <div className='ds-grid ds-grid-cols-1 ds-gap-8 ds-narrow:ds-grid-cols-2 ds-narrow:ds-grid-rows-[auto_auto_auto] ds-narrow:ds-gap-y-0'>
      {[0, 1].map((idx) => (
        <div
          key={idx}
          className='ds-flex ds-flex-col ds-gap-4 ds-narrow:ds-grid ds-narrow:ds-grid-rows-subgrid ds-narrow:ds-row-span-3 ds-narrow:ds-gap-0'
        >
          <Skeleton className='ds-h-6 ds-w-[140px]' />
          <Skeleton className='ds-h-[14px] ds-w-full ds-narrow:ds-mt-3' />
          <Skeleton className='ds-h-ds-xs ds-w-[120px] ds-narrow:ds-mt-4' data-testid='triaged-alarms-metric-skeleton' />
        </div>
      ))}
    </div>
  );
}
